import { get } from "http";
import { Shifting } from "../pages/operations/components/saleOperations/shifting/Shifting";

export const API_URLs = {
  auth: {
    postLogin: "/api/login",
    postRefreshToken: "/api/token/refresh",
    postForgetPwd: "/api/forgot_password/",
    getValidateResetPwdToken: "/api/forgot_password/{tokenValue}",
    postResetPwd: "/api/forgot_password/{tokenValue}",
    profile: "/api/profil",
  },
  menu: {
    getMenus: "/api/menus",
  },
  media: {
    post: "api/image_media",
  },
  missing: {
    getAllMissing: "/api/absences",
    getOneMissing: "/api/absences",
    createMissing: "/api/absences",
    updateMissing: "/api/absences",
    deleteMissing: "/api/absences",
    typeSelect: "/api/absence_types/select",
  },
  staff: {
    getStaff: "/api/staff",

    postStaff: "/api/staff",
    getStaffForSelect: "/api/staff/select",
    getStaffById: "/api/staff/{id}",
    deleteStaffById: "/api/staff/{id}",
    patchStaffById: "/api/staff/{id}",
    departmentSelect: "/api/department_types/select",
  },
  staffPost: {
    getStaffPostSelect: "/api/staff_posts/select",
  },
  transports: {
    get: "/api/transport_orders",
    update: "/api/transport_orders",
    getOne: "/api/transport_orders",
    create: "/api/transport_orders",
    selectState: "/api/transport_order_states/select",
    selectStorage: "/api/storage_loads/select",
    selectTerrePlein: "/api/open_storages/select",
    selectTruckToAssign: "/api/machine_materials/select",
    truckAssign: (id: number) => `/api/transport_orders/${id}/assignment`,
  },
  operations: {
    selectStatus: "/api/operation_states/select",
    detail: {
      getStaff: "/api/teams",
    },
    teamManagement: {
      postTeam: "/api/model_teams",
      getCommercialTeam: "/api/model_teams/commercials",
      getCabotageTeam: "/api/model_teams/cabotages",
      putTeam: "/api/model_teams",
      getOneTeam: "/api/model_teams",
      deleteTeam: "/api/model_teams",
    },
    commercialOperation: {
      getOperations: "/api/operations/commercials",
      getOperationsForSelect: "/api/operation_types/select",
      getOperationsShiftingForSelect: "/api/operation_shiftings/select",
      deleteOperations: "/api/operations",
      getOneOperations: "/api/operations",
      updateOperations: "/api/operations",
      createOperation: "/api/operations",
      createOperations: "/api/operation/process-file-content",
      getAllModelList: "/api/model_teams/select",
    },
    cabotageOperation: {
      getOperations: "/api/operations/cabotages",
      getOperationsForSelect: "/api/operation_types/select",
      getOperationsShiftingForSelect: "/api/operation_shiftings/select",
      deleteOperations: "/api/operations",
      getOneOperations: "/api/operations",
      updateOperations: "/api/operations",
      createOperations: "/api/operation/process-file-content",
      getAllModelList: "/api/model_teams/select",
    },
    planning: {
      getOneModel: "/api/model_teams",
      savePlanning: "/api/operations/{id}/teams",
      getMaterialForPlanning: "/api/operations/{id}/materials",
      patchMaterialForPlanning: "/api/operations/{id}/materials",
      assignementLocation: "/api/assignment_locations/select",
    },
    salesOperations: {
      manifesto: {
        loadTypeSelect: "api/load_types/select",
        loadFillingStatusSelect: "/api/load_filling_status/select",
        returnLocationSelect: "api/return_locations/select",
        loadStatesSelect: "/api/load_states/select",
        loadCategorySelect: "/api/load_categories/select",
        container: "/api/container_loads",
        bagLoads: "/api/bag_loads",
        vehicule: "/api/vehicle_loads",
        craft: {
          craftUrl: "api/craft_loads",
          craftTypeSelect: "/api/craft_types/select",
        },
        other: "api/other_loads",
      },
      overtimeWork: {
        getworks: "/api/extra-works",
      },
      timesheet: {
        getTimeSheet: "/api/time-sheet",
      },
    },
    executionReport: {
      get: "api/operation_bag_load/dockside_execution_report",
    },
    activity: {
      get: "api/daily_activities",
      getOne: "api/daily_activities",
      post: "api/daily_activities",
      patch: "api/daily_activities",
      delete: "api/daily_activities",
      teamList: {
        //get: "/api/model_teams/select"
        get: "api/model_teams/commercials",
      },
    },
    shifting: {
      shiftingOperations: "api/shifting_operations",
      hatchCover: "api/hatch_cover_operations",
      waitingTime: "api/waiting_time_operations",
      select: {
        loadTypeSelect: "api/load_types/select",
        shiftingTypeSelect: "/api/shifting_types/select",
        loadFillingStatusSelect: "/api/load_filling_status/select",
        bargeMaterialSelect: "/api/barge_materials/select",
        hatchCoverActionSelect: "/api/hatch_cover_actions/select",
        pannelPositionSelect: "/api/pannel_positions/select",
        pannelTypeSelect: "/api/pannel_types/select",
      },
    },
    operationFolders: {
      get: "api/operations/{id}/operation_folders",
      post: "api/operation_folders",
      put: "api/operation_folders",
    },
    confrontation: {
      get: "/api/load_confrontations",
      selectType: "/api/confrontation_types/select",
      selectStatus: "/api/load_confrontation_states/select",
    },
  },
  materials: {
    getMaterialType: "/api/materials/{id}/type-count-list",
    getMaterialStateSelect: "/api/material_states/select",
    getMaterialEnergySelect: "/api/material_energies/select",
    getMaterialFromSelect: "/api/material_froms/select",
    getMachineMaterialTypeSelect: "/api/machine_material_types/select",
    getCraneMaterialTypeSelect: "/api/crane_material_types/select",
    getLiftingMaterialTypeSelect: "/api/lifting_material_types/select",
    machine: {
      getMachine: "/api/machine_materials",
      getMachineForSelect: "/api/machine_materials/select",
      getOneMachine: "/api/machine_materials",
      createMachine: "/api/machine_materials",
      updateMachine: "/api/machine_materials",
      deleteMachine: "/api/machine_materials",
    },
    grue: {
      getGrue: "/api/crane_materials",
      getGrueForSelect: "/api/crane_materials/select",
      getOneGrue: "/api/crane_materials",
      createGrue: "/api/crane_materials",
      updateGrue: "/api/crane_materials",
      deleteGrue: "/api/crane_materials",
    },
    levage: {
      getLifting: "/api/lifting_materials",
      getLiftingForSelect: "/api/lifting_materials/select",
      getOneLifting: "/api/lifting_materials",
      createLifting: "/api/lifting_materials",
      updateLifting: "/api/lifting_materials",
      deleteLifting: "/api/lifting_materials",
      levageHistory: "/api/material_controls",
      levageMovement: "/api/material_movements",
      createApprovisionment: "/api/material_movements",
    },
    chaland: {
      getBarge: "/api/barge_materials",
      getBargeForSelect: "/api/barge_materials/select",
      getOneBarge: "/api/barge_materials",
      createBarge: "/api/barge_materials",
      updateBarge: "/api/barge_materials",
      deleteBarge: "/api/barge_materials",
    },
    tugboad: {
      getTugboad: "/api/tugboat_materials",
      getTugboadForSelect: "/api/tugboat_materials/select",
      getOneTugboad: "/api/tugboat_materials",
      createTugboad: "/api/tugboat_materials",
      updateTugboad: "/api/tugboat_materials",
      deleteTugboad: "/api/tugboat_materials",
    },
  },
  settings: {
    roles: {
      getRoles: "/api/user_roles",
      postNewRole: "/api/user_roles",
      getRoleSelect: "/api/user_roles/select",
      getRoleById: "/api/user_roles/{id}",
      deleteRoleById: "/api/user_roles/{id}",
      patchRoleById: "/api/user_roles/{id}",
      rolesUrl: "/api/user_roles",
      roleMenus: "/api/menus",
    },
    users: {
      getUsers: "/api/users",
      postUser: "/api/users",
      getUsersSelect: "/api/users/select",
      getUserById: "/api/users/{id}",
      deleteUserById: "/api/users/{id}",
      patchUserById: "/api/users/{id}",
      usersUrl: "api/users",
    },
    storages: {
      getStorages: "/api/storages",
      postStorage: "/api/storages",
      getStorageSelect: "/api/storages/select",
      getStorageById: "/api/storages/{id}",
      deleteStorageById: "/api/storages/{id}",
      patchStorageById: "/api/storages/{id}",
      storageUrl: "/api/storages",
      storageLoads: "/api/storage_loads",
      historyList: "/api/storage_movement_histories",
      stateSelect: "/api/storage_load_state/select",
      historyDetail: "/api/storage_movement_histories",
      importGateIn: "/api/gate-ins/import-file-content",
    },
    customers: {
      getCustomerList: "/api/customers",
      postCustomer: "/api/customers",
      getCustomerSelect: "/api/customers/select",
      getCustomerCategory: "/api/customer_categories/select",
      getCustomerById: "/api/customers/{id}",
      deleteCustomerById: "/api/customers/{id}",
      patchCustomerById: "/api/customers/{id}",
      categoryForSelect: "/api/customer_categories/select",
    },
    materials: {
      postMaterial: "/api/materials",
      getMaterialList: "/api/materials",
      getMaterialById: "/api/materials/{id}",
      deleteMaterialById: "/api/materials/{id}",
      patchMaterialById: "/api/materials/{id}",
      getMaterialTypes: "/api/material_types",
      getMaterialStates: "/api/material_states/select",
      getMaterialEnergies: "/api/material_energies/select",
    },

    materialType: {
      getMaterialTypes: "/api/material_types",
      postMaterialType: "/api/material_types",
      getMaterialTypesForSelect: "/api/material_material_types/select",
      getMaterialTypeById: "/api/material_types/{id}",
      deleteMaterialTypeById: "/api/material_types/{id}",
      patchMaterialTypeById: "/api/material_types/{id}",
    },
    openStorage: {
      // getOpenStorages: "/api/open_storages",
      // postOpenStorage: "/api/open_storages",
      getOpenStoragesForSelect: "/api/open_storages/select",
      // getOpenStorageById: "/api/open_storages/{id}",
      // deleteOpenStorageById: "/api/open_storages/{id}",
      // patchOpenStorageById: "/api/open_storages/{id}",
      openStorageUrl: "/api/open_storages",
    },
    storeStorage: {
      // getStoreStorages: "/api/store_storages",
      // postStoreStorage: "/api/store_storages",
      getStoreStoragesForSelect: "/api/store_storages/select",
      // getStoreStorageById: "/api/store_storages/{id}",
      // deleteStoreStorageById: "/api/store_storages/{id}",
      // patchStoreStorageById: "/api/store_storages/{id}",
      storeStorageUrl: "/api/store_storages",
    },
    containerType: {
      // getContainerTypes: "/api/container_types",
      // postContainerType: "/api/container_types",
      getContainerTypesForSelect: "/api/container_types/select",
      // getContainerTypeById: "/api/container_types/{id}",
      // deleteContainerTypeById: "/api/container_types/{id}",
      // patchContainerTypeById: "/api/container_types/{id}",
      containerTypeUrl: "/api/container_types",
      getContainerUnitsForSelect: "/api/container_units/select",
      getContainerCategoryForSelect: "/api/container_categories/select",
    },
    /* cementPackaging: {
      // getCementPackagingList: "/api/cement_packagings",
      // postCementPackaging: "/api/cement_packagings",
      // getCementPackagingForSelect: "/api/cement_packagings/select",
      // getCementPackagingById: "/api/cement_packagings/{id}",
      // deleteCementPackagingById: "/api/cement_packagings/{id}",
      // patchCementPackagingById: "/api/cement_packagings/{id}",
    }, */
    damaged: "/api/load_damages",
    damagedType: "/api/damage_types",
    damagedZone: "/api/damage_zones",
    cementPackaging: "/api/cement_packagings",

    workCalendar: {
      workShedule: {
        getOneTime: "/api/work_schedules",
        patchTime: "/api/work_schedules",
      },
      publicHolidays: {
        getHolidays: "/api/public_holidays",
        createHoliday: "/api/public_holidays",
        getOneHoliday: "/api/public_holidays",
        patchHoliday: "/api/public_holidays",
        deleteHoliday: "/api/public_holidays",
      },
    },
  },
  dashboard: {
    getNumberOperations: "api/kpi/operation/count",
    getOperationDistribution: "/api/kpi/operation/distribution",
    getOperationalSummary: "/api/kpi/operation/operational-summary",
    getOperationaFeature: "api/operations/futures",
  },
  merchandise: {
    container: "/api/container_loads",
    bag: "/api/bag_loads",
    vehicle: "/api/vehicle_loads",
    craft: "api/craft_loads",
    other: "api/other_loads",
  },
};
